export const SET_PARTICIPANT = 'PARTICIPANT/SET_PARTICIPANT'
export const SET_LOGTRANSACTION = 'PARTICIPANT/SET_LOGTRANSACTION'
export const SET_PARTICIPANTS = 'PARTICIPANT/SET_PARTICIPANTS'
